import { MaintenanceLayout } from './MaintenanceLayout';

interface OfflineStateProps {
  onTryAgain: () => void;
}

/**
 * Offline state: navigator.onLine === false. Recovery is automatic via
 * the browser 'online' event listener installed by initializeMaintenance,
 * which re-runs the discriminator probe (with reason 'manual' to bypass
 * debounce) when the browser reports network is back. The user can also
 * tap Try Again (rendered by MaintenanceLayout) to re-probe immediately.
 */
export function OfflineState({ onTryAgain }: OfflineStateProps) {
  return (
    <MaintenanceLayout onTryAgain={onTryAgain}>
      <img src="/signup-mascot.svg" alt="" className="w-24 h-24 mx-auto mb-2" aria-hidden="true" />
      {/* h2 (not h1): see MaintenanceState.tsx for outline rationale. */}
      <h2 className="text-xl font-semibold text-gray-900">You&apos;re offline.</h2>
      <p className="text-sm text-gray-600">We&apos;ll be here when you&apos;re back online.</p>
    </MaintenanceLayout>
  );
}
